<template>
  <iframe :src="frameUrl"
          width="900"
          height="1300"
          style="border:none;padding-bottom:96px;" />
</template>
<script>
import httpService from '@/helper/httpService';
export default {
  name: "KomedexPage",
  props: {
    frameUrl: {
      type: String,
      default: httpService.adjustLegacyUrl('/maklerportal/komedex.aspx')
    }
  }
};
</script>
